// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Cloud } from './Cloud';
export class Clouds {
    constructor(indicator) {
        this.clouds = [];
        this.dClouds = new Map();
        this.indicator = indicator;
    }
    get count() {
        return this.clouds.length;
    }
    get(index) {
        if (index < 0 || index >= this.count) {
            throw new RangeError('Index out of range');
        }
        return this.clouds[index];
    }
    set(name, gradientMode, colorAscending, colorDescending) {
        const cloud = new Cloud(this.indicator, this.clouds.length, gradientMode, colorAscending, colorDescending);
        this.clouds.push(cloud);
        this.dClouds[name] = cloud;
    }
    getByName(name) {
        const cloud = this.dClouds.get(name);
        if (isNullOrUndefined(cloud)) {
            throw new RangeError('Cloud with given name not found');
        }
        return cloud;
    }
}
